module.exports = __webpack_public_path__ + "img/orange-heart.a73b1a94.png";